import React, { useEffect, useState } from 'react';

import {
  EmailStep,
  FormField as Item,
  FormState,
} from 'app/developer-v3/teams/team-technical-support-operations/get-help';
import {
  getFromForcedObject,
  setInForcedObject,
} from 'app/developer-v3/components/PartnerSupportForm/utils';

type ContactProps = {
  answer: (stepData?: any) => void;
  canContinue: boolean;
  data: any;
  isSubmitting: boolean;
  items: Item[];
  onModalBack: () => void;
  onModalClose: () => void;
  setMeta: (key: string, value: string) => void;
  submit: () => Promise<void>;
};

const Contact = ({
  answer,
  canContinue: hasCompletedRequiredFields,
  data,
  isSubmitting,
  items = [],
  setMeta,
  submit,
}: ContactProps) => {
  // formState -----------------------------------------------------------------
  const [formState, setFormState] = useState<FormState>('initial');
  useEffect(() => {
    let state: FormState = 'initial';
    if (isSubmitting) {
      state = 'submitting';
    } else if (hasCompletedRequiredFields) {
      state = 'readyToSubmit';
    }
    setFormState(state);
  }, [hasCompletedRequiredFields, isSubmitting]);

  // fields --------------------------------------------------------------------
  const createOnChangeField = (id: string) => (value: string) => {
    answer(setInForcedObject(data, id, value));
    // NOTE: We could make email and name a field-type to decouple this.
    if (value && (id === 'email' || id === 'full_name')) {
      setMeta(id, value);
    }
  };
  const fields = items.map(item => ({
    onChange: createOnChangeField(item.id),
    staticProperties: item,
    value: getFromForcedObject(data, item.id) || '',
  }));

  return <EmailStep fields={fields} formState={formState} onSubmit={submit} />;
};

export default Contact;
